var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    zoomAndPan: "magnify",
    viewBox: "0 0 705 260.999984",
    height: 348,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa825f486b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 226.335938 95.496094 L 296.085938 95.496094 L 296.085938 165.246094 L 226.335938 165.246094 Z M 226.335938 95.496094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f48547dfea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 266.554688 128.191406 L 235.304688 128.191406 C 234.09375 128.191406 233.214844 127.035156 233.542969 125.871094 L 242.121094 95.296875 C 242.34375 94.507812 243.0625 93.960938 243.882812 93.960938 L 275.132812 93.960938 C 276.34375 93.960938 277.21875 95.117188 276.894531 96.285156 L 268.316406 126.859375 C 268.09375 127.648438 267.375 128.191406 266.554688 128.191406 Z M 246.257812 151.269531 L 250.675781 135.527344 C 251 134.363281 250.125 133.203125 248.914062 133.203125 L 232.847656 133.203125 C 232.03125 133.203125 231.308594 133.75 231.089844 134.539062 L 226.671875 150.28125 C 226.34375 151.449219 227.21875 152.605469 228.433594 152.605469 L 244.496094 152.605469 C 245.316406 152.605469 246.035156 152.058594 246.257812 151.269531 Z M 254.386719 134.539062 L 245.808594 165.113281 C 245.480469 166.28125 246.355469 167.4375 247.566406 167.4375 L 278.816406 167.4375 C 279.636719 167.4375 280.355469 166.890625 280.578125 166.101562 L 289.15625 135.527344 C 289.484375 134.363281 288.605469 133.203125 287.394531 133.203125 L 256.148438 133.203125 C 255.328125 133.203125 254.605469 133.75 254.386719 134.539062 Z M 276.441406 110.128906 L 272.027344 125.871094 C 271.699219 127.035156 272.574219 128.191406 273.789062 128.191406 L 289.851562 128.191406 C 290.671875 128.191406 291.390625 127.648438 291.613281 126.859375 L 296.027344 111.117188 C 296.355469 109.949219 295.480469 108.792969 294.265625 108.792969 L 278.203125 108.792969 C 277.382812 108.792969 276.664062 109.339844 276.441406 110.128906 Z M 276.441406 110.128906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 117.962504,
    gradientTransform: "matrix(0.146952, 0, 0, 0.146952, 226.601878, 93.961124)",
    y1: -38.702073,
    x2: 353.117757,
    gradientUnits: "userSpaceOnUse",
    y2: 534.223991,
    id: "a3fd892769"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.898499%, 55.699158%, 62.69989%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.898499%, 55.699158%, 62.69989%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.898499%, 55.699158%, 62.69989%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.878662%, 55.567932%, 62.852478%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.835938%, 55.2948%, 63.171387%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.791687%, 55.00946%, 63.50708%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.745911%, 54.722595%, 63.841248%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.70166%, 54.437256%, 64.175415%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.65741%, 54.150391%, 64.511108%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.613159%, 53.865051%, 64.845276%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.567383%, 53.578186%, 65.180969%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.523132%, 53.292847%, 65.515137%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.478882%, 53.005981%, 65.849304%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.434631%, 52.720642%, 66.184998%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.388855%, 52.433777%, 66.519165%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.344604%, 52.148438%, 66.854858%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.300354%, 51.861572%, 67.189026%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.254578%, 51.576233%, 67.523193%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.210327%, 51.289368%, 67.858887%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.166077%, 51.004028%, 68.193054%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.121826%, 50.717163%, 68.528748%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.07605%, 50.431824%, 68.862915%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.031799%, 50.144958%, 69.197083%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.987549%, 49.859619%, 69.532776%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.943298%, 49.572754%, 69.866943%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.897522%, 49.287415%, 70.202637%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.853271%, 49.000549%, 70.536804%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.809021%, 48.71521%, 70.870972%)",
    offset: 0.273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.764771%, 48.428345%, 71.206665%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.718994%, 48.143005%, 71.540833%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.674744%, 47.85614%, 71.876526%)",
    offset: 0.290986
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.653381%, 47.714233%, 72.044373%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.630493%, 47.570801%, 72.210693%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.586243%, 47.283936%, 72.544861%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.540466%, 46.998596%, 72.880554%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.496216%, 46.711731%, 73.214722%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.451965%, 46.426392%, 73.550415%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.407715%, 46.139526%, 73.884583%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.361938%, 45.854187%, 74.21875%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.317688%, 45.567322%, 74.554443%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.273438%, 45.281982%, 74.888611%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.229187%, 44.995117%, 75.224304%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.183411%, 44.709778%, 75.558472%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.13916%, 44.422913%, 75.892639%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.09491%, 44.137573%, 76.228333%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.050659%, 43.850708%, 76.5625%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.004883%, 43.565369%, 76.898193%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.960632%, 43.278503%, 77.232361%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.916382%, 42.993164%, 77.566528%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.872131%, 42.707825%, 77.902222%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.826355%, 42.420959%, 78.236389%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.782104%, 42.13562%, 78.572083%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.737854%, 41.848755%, 78.90625%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.693604%, 41.563416%, 79.240417%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.647827%, 41.27655%, 79.576111%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.603577%, 40.991211%, 79.910278%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.559326%, 40.704346%, 80.245972%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.515076%, 40.419006%, 80.580139%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.469299%, 40.132141%, 80.914307%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.425049%, 39.846802%, 81.25%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.380798%, 39.559937%, 81.584167%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.336548%, 39.274597%, 81.919861%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.290771%, 38.987732%, 82.254028%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.246521%, 38.702393%, 82.588196%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.202271%, 38.415527%, 82.923889%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.15802%, 38.130188%, 83.258057%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.112244%, 37.843323%, 83.59375%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.067993%, 37.557983%, 83.927917%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.023743%, 37.271118%, 84.262085%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.979492%, 36.985779%, 84.597778%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.933716%, 36.698914%, 84.931946%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.889465%, 36.413574%, 85.267639%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.845215%, 36.126709%, 85.601807%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.800964%, 35.84137%, 85.935974%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.755188%, 35.554504%, 86.271667%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.710938%, 35.269165%, 86.605835%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.666687%, 34.9823%, 86.941528%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.622437%, 34.69696%, 87.275696%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.57666%, 34.410095%, 87.609863%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.53241%, 34.124756%, 87.945557%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.488159%, 33.837891%, 88.279724%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.443909%, 33.552551%, 88.615417%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.398132%, 33.265686%, 88.949585%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.353882%, 32.980347%, 89.283752%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.309631%, 32.693481%, 89.619446%)",
    offset: 0.709014
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.288269%, 32.551575%, 89.787292%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.265381%, 32.408142%, 89.953613%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.219604%, 32.121277%, 90.289307%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.175354%, 31.835938%, 90.623474%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.131104%, 31.549072%, 90.957642%)",
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.086853%, 31.263733%, 91.293335%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.041077%, 30.976868%, 91.627502%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.996826%, 30.691528%, 91.963196%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.952576%, 30.406189%, 92.297363%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.906799%, 30.119324%, 92.631531%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.862549%, 29.833984%, 92.967224%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.818298%, 29.547119%, 93.301392%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.774048%, 29.26178%, 93.637085%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.728271%, 28.974915%, 93.971252%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.684021%, 28.689575%, 94.30542%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.639771%, 28.40271%, 94.641113%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.59552%, 28.117371%, 94.975281%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.549744%, 27.830505%, 95.310974%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.513123%, 27.593994%, 95.588684%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.49939%, 27.49939%, 95.698547%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fa825f486b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f48547dfea)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a3fd892769)",
    d: "M 226.34375 95.496094 L 226.34375 165.246094 L 296.085938 165.246094 L 296.085938 95.496094 Z M 226.34375 95.496094 ",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.359674, 144.402052)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.90625 0 L 3.53125 0 L 3.53125 -27.15625 L 8.90625 -27.15625 Z M 8.90625 0 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(324.803214, 144.402052)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.953125 0 L 2.953125 -20.484375 L 7.890625 -20.484375 L 7.890625 -17.484375 L 8.28125 -17.390625 C 9.5625 -19.710938 11.628906 -20.875 14.484375 -20.875 C 16.847656 -20.875 18.582031 -20.226562 19.6875 -18.9375 C 20.800781 -17.65625 21.359375 -15.78125 21.359375 -13.3125 L 21.359375 0 L 16.21875 0 L 16.21875 -12.6875 C 16.21875 -14.050781 15.941406 -15.03125 15.390625 -15.625 C 14.847656 -16.226562 13.976562 -16.53125 12.78125 -16.53125 C 11.3125 -16.53125 10.160156 -16.050781 9.328125 -15.09375 C 8.503906 -14.144531 8.09375 -12.648438 8.09375 -10.609375 L 8.09375 0 Z M 2.953125 0 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(348.798816, 144.402052)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 14.140625 -4.890625 L 15.46875 -1.078125 C 14.914062 -0.617188 14.21875 -0.257812 13.375 0 C 12.53125 0.257812 11.578125 0.390625 10.515625 0.390625 C 8.296875 0.390625 6.609375 -0.210938 5.453125 -1.421875 C 4.304688 -2.628906 3.734375 -4.382812 3.734375 -6.6875 L 3.734375 -16.421875 L 0.609375 -16.421875 L 0.609375 -20.515625 L 3.734375 -20.515625 L 3.734375 -24.5 L 8.875 -25.34375 L 8.875 -20.515625 L 14.6875 -20.515625 L 14.6875 -16.421875 L 8.875 -16.421875 L 8.875 -7.0625 C 8.875 -6.039062 9.082031 -5.296875 9.5 -4.828125 C 9.925781 -4.367188 10.539062 -4.140625 11.34375 -4.140625 C 12.257812 -4.140625 13.0625 -4.390625 13.75 -4.890625 Z M 14.140625 -4.890625 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(364.71541, 144.402052)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 20.25 -9.078125 L 7.078125 -9.078125 C 7.222656 -7.296875 7.726562 -6 8.59375 -5.1875 C 9.46875 -4.375 10.65625 -3.96875 12.15625 -3.96875 C 13.332031 -3.96875 14.285156 -4.1875 15.015625 -4.625 C 15.742188 -5.070312 16.332031 -5.738281 16.78125 -6.625 L 17.171875 -6.625 L 20.578125 -4.4375 C 19.910156 -3 18.898438 -1.832031 17.546875 -0.9375 C 16.203125 -0.0507812 14.40625 0.390625 12.15625 0.390625 C 10.03125 0.390625 8.195312 -0.0078125 6.65625 -0.8125 C 5.113281 -1.625 3.925781 -2.820312 3.09375 -4.40625 C 2.257812 -6 1.84375 -7.941406 1.84375 -10.234375 C 1.84375 -12.566406 2.28125 -14.53125 3.15625 -16.125 C 4.039062 -17.71875 5.226562 -18.90625 6.71875 -19.6875 C 8.21875 -20.476562 9.90625 -20.875 11.78125 -20.875 C 14.675781 -20.875 16.894531 -20.109375 18.4375 -18.578125 C 19.976562 -17.046875 20.75 -14.789062 20.75 -11.8125 C 20.75 -10.738281 20.710938 -9.90625 20.640625 -9.3125 Z M 15.828125 -12.40625 C 15.773438 -13.96875 15.410156 -15.101562 14.734375 -15.8125 C 14.066406 -16.53125 13.082031 -16.890625 11.78125 -16.890625 C 9.175781 -16.890625 7.644531 -15.394531 7.1875 -12.40625 Z M 15.828125 -12.40625 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(386.98378, 144.402052)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.515625 0.390625 C 6.660156 0.390625 5.25 -0.101562 4.28125 -1.09375 C 3.3125 -2.09375 2.828125 -3.609375 2.828125 -5.640625 L 2.828125 -28.71875 L 7.96875 -28.71875 L 7.96875 -5.859375 C 7.96875 -4.597656 8.488281 -3.96875 9.53125 -3.96875 C 9.820312 -3.96875 10.140625 -4.019531 10.484375 -4.125 L 10.734375 -4.046875 L 11.203125 -0.09375 C 10.921875 0.0507812 10.539062 0.164062 10.0625 0.25 C 9.59375 0.34375 9.078125 0.390625 8.515625 0.390625 Z M 8.515625 0.390625 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(398.758712, 144.402052)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.515625 0.390625 C 6.660156 0.390625 5.25 -0.101562 4.28125 -1.09375 C 3.3125 -2.09375 2.828125 -3.609375 2.828125 -5.640625 L 2.828125 -28.71875 L 7.96875 -28.71875 L 7.96875 -5.859375 C 7.96875 -4.597656 8.488281 -3.96875 9.53125 -3.96875 C 9.820312 -3.96875 10.140625 -4.019531 10.484375 -4.125 L 10.734375 -4.046875 L 11.203125 -0.09375 C 10.921875 0.0507812 10.539062 0.164062 10.0625 0.25 C 9.59375 0.34375 9.078125 0.390625 8.515625 0.390625 Z M 8.515625 0.390625 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.533644, 144.402052)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 20.25 -9.078125 L 7.078125 -9.078125 C 7.222656 -7.296875 7.726562 -6 8.59375 -5.1875 C 9.46875 -4.375 10.65625 -3.96875 12.15625 -3.96875 C 13.332031 -3.96875 14.285156 -4.1875 15.015625 -4.625 C 15.742188 -5.070312 16.332031 -5.738281 16.78125 -6.625 L 17.171875 -6.625 L 20.578125 -4.4375 C 19.910156 -3 18.898438 -1.832031 17.546875 -0.9375 C 16.203125 -0.0507812 14.40625 0.390625 12.15625 0.390625 C 10.03125 0.390625 8.195312 -0.0078125 6.65625 -0.8125 C 5.113281 -1.625 3.925781 -2.820312 3.09375 -4.40625 C 2.257812 -6 1.84375 -7.941406 1.84375 -10.234375 C 1.84375 -12.566406 2.28125 -14.53125 3.15625 -16.125 C 4.039062 -17.71875 5.226562 -18.90625 6.71875 -19.6875 C 8.21875 -20.476562 9.90625 -20.875 11.78125 -20.875 C 14.675781 -20.875 16.894531 -20.109375 18.4375 -18.578125 C 19.976562 -17.046875 20.75 -14.789062 20.75 -11.8125 C 20.75 -10.738281 20.710938 -9.90625 20.640625 -9.3125 Z M 15.828125 -12.40625 C 15.773438 -13.96875 15.410156 -15.101562 14.734375 -15.8125 C 14.066406 -16.53125 13.082031 -16.890625 11.78125 -16.890625 C 9.175781 -16.890625 7.644531 -15.394531 7.1875 -12.40625 Z M 15.828125 -12.40625 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(432.802014, 144.402052)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 14.09375 0 L 7.96875 0 L 0.390625 -20.484375 L 5.78125 -20.484375 L 10.875 -5.890625 L 11.296875 -5.890625 L 16.40625 -20.484375 L 21.65625 -20.484375 Z M 14.09375 0 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(454.828938, 144.402052)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 11.90625 0.390625 C 9.90625 0.390625 8.144531 -0.0195312 6.625 -0.84375 C 5.101562 -1.664062 3.925781 -2.875 3.09375 -4.46875 C 2.257812 -6.0625 1.84375 -7.984375 1.84375 -10.234375 C 1.84375 -12.492188 2.257812 -14.421875 3.09375 -16.015625 C 3.925781 -17.609375 5.101562 -18.816406 6.625 -19.640625 C 8.144531 -20.460938 9.90625 -20.875 11.90625 -20.875 C 13.914062 -20.875 15.675781 -20.460938 17.1875 -19.640625 C 18.707031 -18.816406 19.890625 -17.609375 20.734375 -16.015625 C 21.578125 -14.421875 22 -12.492188 22 -10.234375 C 22 -7.984375 21.578125 -6.0625 20.734375 -4.46875 C 19.890625 -2.875 18.707031 -1.664062 17.1875 -0.84375 C 15.675781 -0.0195312 13.914062 0.390625 11.90625 0.390625 Z M 11.90625 -3.96875 C 15.09375 -3.96875 16.6875 -6.054688 16.6875 -10.234375 C 16.6875 -12.398438 16.273438 -13.988281 15.453125 -15 C 14.640625 -16.007812 13.457031 -16.515625 11.90625 -16.515625 C 8.726562 -16.515625 7.140625 -14.421875 7.140625 -10.234375 C 7.140625 -6.054688 8.726562 -3.96875 11.90625 -3.96875 Z M 11.90625 -3.96875 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.1a5650052cb75c4ddb13e670bf4dfcc5.svg";
export { ForwardRef as ReactComponent };